module.exports = __webpack_public_path__ + "static/img/iconfont.b3ea1d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/iconfont.svg?t=1506051110772
// module id = 196
// module chunks = 10